<ejs-dialog
	#modal
	(close)="closeModal()"
	id="patient-letter-dockable-modal"
	cssClass="dockable-modal"
	[class]="{'dialog-maximized': maximized, 'dialog-minimized': !maximized}"
	[attr.data-test-id]="'dockableLetterEditorModal'"
	[width]="900"
	[height]="'93%'"
	[allowDragging]="false"
	[isModal]="false"
	[position]="{X: 'right', Y: 'top'}">
	<rev-loading-overlay [loading]="_isLoading">
		<ng-template #header>
			<span class='title'>Write Letter</span>
			<span class="header-btns">
        @if (!maximized) {
			<maj-button
				icon="window-maximize"
				dataTestId="letterEditorMaximizeButton"
				(click)='maximize()'>
          </maj-button>
		}
				@if (maximized) {
					<maj-button
						icon="window-minimize"
						dataTestId="letterEditorMinimizeButton"
						(click)='minimize()'>
          </maj-button>
				}
      </span>
		</ng-template>
		<ng-template #content>
			<div class="modal-feature">
				<h4 class="margin-0">{{ patientDocumentResponse?.documentName }}</h4>
			</div>
			@if (!froalaDataLoading) {
				<maj-rich-text-editor [formControl]="documentContentControl"></maj-rich-text-editor>
			}
		</ng-template>
		<ng-template #footerTemplate>
			<maj-button
				icon="print"
				label="Print"
				variant="primary"
				(clicked)="openPdfViewer(true)"
				dataTestId="letterEditorPrintButton">
			</maj-button>
			<maj-button
				icon="file-pdf-o"
				label="PDF"
				variant="primary"
				(clicked)="openPdfViewer(false)"
				dataTestId="letterEditorPdfButton">
			</maj-button>
			<maj-button
				type="submit"
				label="Save Draft"
				variant="primary"
				(clicked)="updatePatientDocument()"
				dataTestId="letterEditorSaveButton">
			</maj-button>
		</ng-template>
	</rev-loading-overlay>
</ejs-dialog>
